import { EyeOutlined } from "@ant-design/icons";
import { Campos, Detail, IErroApi } from "../Interfaces/Interfaces";
import { messageApi, modalApi } from "../config/AntdGlobalProvider";


export function errorMessage(text: string) {
  return messageApi.error({
    // icon: (
    //   <Row justify="end">
    //     <Col span={3}>
    //       <Button id='error' type="link" onClick={() => message.destroy(key)}>
    //         <CloseOutlined />
    //       </Button>
    //     </Col>
    //   </Row>
    // ),
    // key: key,
    // content: (
    //   <Row justify="end">
    //     <Col span={24} style={{ padding: 20, paddingTop: 0, }}>
    //       <Row justify="center">
    //         <CloseCircleOutlined />
    //         <Text>{text}</Text>
    //       </Row>
    //     </Col>
    //   </Row>
    // ),
    content: text,
    duration: 5,
    className: "custom-class",
  });
}

export function successMessage(text: string) {
  return messageApi.success({
    // icon: (
    //   <Row justify="end">
    //     <Col span={3}>
    //       <Button id='success' type="link" onClick={() => message.destroy(key)}>
    //         <CloseOutlined />
    //       </Button>
    //     </Col>
    //   </Row>
    // ),
    // key: key,
    // content: (
    //   <Row justify="end">
    //     <Col span={24} style={{ padding: 20, paddingTop: 0, }}>
    //       <Row justify="center">
    //         <CheckCircleOutlined />
    //         <Text>{text}</Text>
    //       </Row>
    //     </Col>
    //   </Row>
    // ),
    content: text,
    duration: 5,
    className: "custom-class",
  });
}

export function infoMessage(text: string) {
  const key = Math.random();

  messageApi.info({
    // icon: (
    //   <Row justify="end">
    //     <Col span={3}>
    //       <Button id='info' type="link" onClick={() => message.destroy(key)}>
    //         <CloseOutlined />
    //       </Button>
    //     </Col>
    //   </Row>
    // ),
    key: key,
    // content: (
    //   <Row justify="end">
    //     <Col span={24} style={{ padding: 20, paddingTop: 0, }}>
    //       <Row justify="center">
    //         <InfoCircleOutlined />
    //         <Text>{text}</Text>
    //       </Row>
    //     </Col>
    //   </Row>
    // ),
    content: text,
    duration: 5,
    className: "custom-class",
  });
}

export function mostrarInfo(title: string, msg: string) {
  modalApi.info({
    title: title,
    width: "400px",
    icon: <EyeOutlined />,
    content: msg,
  });
}

export function mostrarInfoDetail(title: string, erroApi: IErroApi) {
  let msg = erroApi.mensagem;

  const details: Detail[] = erroApi.details;
  const campos: Campos[] = erroApi.campos;

  if ((!details || details.length === 0) && (!campos || campos.length === 0)) {
    modalApi.info({
      title: title,
      width: "600px",
      icon: <EyeOutlined />,
      content: msg
    });
    return
  }

  if (details && details.length > 0) {
    modalApi.info({
      title: title,
      width: "600px",
      icon: <EyeOutlined />,
      content:
        <div>
          {msg}
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            {details.map((detail, index) => (
              <li key={index}>{detail.errors[1] !== "" ? "Cod.: " + detail.errors[1] + " - " : ""}  {detail.defaultMessage}</li>
            ))}
          </ul>
        </div>
    });
    return
  }

  if (campos && campos.length > 0) {
    modalApi.info({
      title: title,
      width: "600px",
      icon: <EyeOutlined />,
      content:
        <div>
          {msg}
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            {campos.map((campo, index) => (
              <li key={index}>Campo: {campo.cnome} - {campo.cmensagem}</li>
            ))}
          </ul>
        </div>
    });
  }
}
